import React, { useEffect } from 'react'
import { Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { cloneChildComponents } from '../../../utils/helpers'

// Handles the view of GWS_SUSPEND_SIGN_IN
function SuspendSignIn(props) {
  const { children, ...rest } = props // eslint-disable-line react/prop-types
  const { intl, setDisableSubmit, disableSubmit, setCompletedActions } = rest

  const SUSPEND_SIGN_IN_ACTION_ID = 'ENGAGE.SUSPEND_SIGN_IN_SUCCESS'

  // Handles setting the completed action
  useEffect(() => {
    setCompletedActions((alreadyCompletedActions) => [...alreadyCompletedActions, SUSPEND_SIGN_IN_ACTION_ID])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <PerfectScrollbar options={{ wheelSpeed: 2, wheelPropagation: false }} className="paginator-margin-bottom">
      <Form>
        <Modal.Body>
          <Row>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <p>
                <FormattedMessage id="ENGAGE.SUSPEND_SIGN_IN_PHRASE_1" />
              </p>
              <p style={{ marginBottom: '0px' }}>
                <FormattedMessage id="ENGAGE.SUSPEND_SIGN_IN_PHRASE_2" />
              </p>
              <ul className="ps-3">
                <li className="mb-0" style={{ marginLeft: '0.5rem' }}>
                  <FormattedMessage id="ENGAGE.SUSPEND_SIGN_IN_PHRASE_3" />
                </li>
                <li className="mb-0" style={{ marginLeft: '0.5rem' }}>
                  <FormattedMessage id="ENGAGE.SUSPEND_SIGN_IN_PHRASE_4" />
                </li>
                <li className="mb-0" style={{ marginLeft: '0.5rem' }}>
                  <FormattedMessage id="ENGAGE.SUSPEND_SIGN_IN_PHRASE_5" />
                </li>
              </ul>
              <div>
                <Form.Group id="formGridCheckbox">
                  <Form.Check
                    custom
                    type="checkbox"
                    id="confirmBlock"
                    checked={disableSubmit === false}
                    defaultChecked={disableSubmit === false}
                    label={
                      intl
                        ? intl.formatMessage({
                            id: 'ENGAGE.SUSPEND_SING_IN_CHECKBOX_PHRASE',
                          })
                        : ''
                    }
                    onClick={() => {
                      setDisableSubmit(disableSubmit === false)
                    }}
                  />
                </Form.Group>
              </div>
            </div>
          </Row>
        </Modal.Body>

        {/* Footer Child */}
        {cloneChildComponents({ ...rest }, children)}
      </Form>
    </PerfectScrollbar>
  )
}

export default SuspendSignIn
